import "../../styles.css";

const SupportPage = () => {
  return (
    <div className="terms-of-use-container">
      <header className="terms-of-use-header">
        <h1>Support</h1>
        <h2>Gig Genie</h2>
      </header>

      <section className="terms-of-use-section">
        <h3>FAQs</h3>

        <p><strong>How do I cancel my subscription?</strong></p>
        <p>Open your device Settings → App Store or Google Play → Subscriptions. Find Gig Genie and tap Cancel. Your access continues until the end of the current billing period.</p>

        <p><strong>How do I export my data for taxes?</strong></p>
        <p>In the app, go to the tax or earnings section and use the export or download option to generate a PDF. You can email or save it for your records.</p>

        <p><strong>The app won’t open or keeps crashing. What should I do?</strong></p>
        <p>Force close the app, restart your device, then open Gig Genie again. If it still fails, check for an app update in the App Store or Google Play. If the problem continues, contact us (see Contact Us below).</p>

        <p><strong>I switched devices. How do I get my data back?</strong></p>
        <p>Gig Genie stores data on your device. If you had a backup or signed in with an account, restore from that. For help recovering data, contact us with your previous and new device details.</p>

        <p><strong>How do I get help with a billing or payment issue?</strong></p>
        <p>Refunds and payment issues are handled by Apple (App Store) or Google (Google Play). You can request a refund in the App Store or Google Play subscription or purchase history. For other billing questions, contact us at the email below.</p>
      </section>

      <section className="terms-of-use-section">
        <h3>Contact Us</h3>
        <p>
          For support, feedback, or questions about Gig Genie, email us at{" "}
          <a href="mailto:mygiggenie@gmail.com">mygiggenie@gmail.com</a>. We aim to respond within 1–2 business days.
        </p>
      </section>

      <section className="terms-of-use-section">
        <h3>Troubleshooting</h3>
        <p>If something isn’t working as expected, try these steps in order:</p>
        <ol>
          <li><strong>Close and reopen the app.</strong> Swipe the app away from your recent apps, then open Gig Genie again.</li>
          <li><strong>Restart your device.</strong> Turn your phone or tablet off and on, then open the app.</li>
          <li><strong>Update the app.</strong> In the App Store or Google Play, check for a Gig Genie update and install it.</li>
          <li><strong>Check storage and connectivity.</strong> Ensure you have enough free storage and a stable internet connection if the app uses sync or online features.</li>
          <li><strong>Reinstall the app (last resort).</strong> Uninstall Gig Genie, then install it again from the store. Note: data stored only on the device may be lost unless you have a backup.</li>
        </ol>
        <p>If the issue continues, contact us at <a href="mailto:mygiggenie@gmail.com">mygiggenie@gmail.com</a> with a short description of the problem and your device type and OS version.</p>
      </section>
    </div>
  );
};

export default SupportPage;
